import React from "react";
import { SecondaryButton } from "cdk-radial";
import "./styles.css";

const DownloadCSVFile = ({ downloadIntegrationCSV, accessToken }) => {
  const getCurrentMonthRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const format = (date) => date.toLocaleDateString("en-CA");
    return { startDate: format(start), endDate: format(end) };
  };
  const handleDownload = async () => {
    const { startDate, endDate } = getCurrentMonthRange();

    try {
      const data = await downloadIntegrationCSV({
        accessToken,
        startDate,
        endDate,
      });

      const csv = prepareCSV(data);

      const now = new Date();
      const pad = (num) => String(num).padStart(2, "0");

      const timestamp = `\
${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${now.getFullYear()}-\
${pad(now.getHours())}.${pad(now.getMinutes())}.${pad(now.getSeconds())}`;

      const fileName = `IntegrationReport-${timestamp}.csv`;

      downloadCSV(csv, fileName);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const prepareCSV = (res) => {
    const newLine = "\n";
    const headerData = [
      "App Org",
      "App Org ID",
      "App",
      "App ID",
      "API Name",
      "API ID",
      "API Publisher",
      "API Publisher ID",
    ];

    const csvData = [headerData];

    if (Array.isArray(res) && res.length > 0) {
      res.forEach((object) => {
        const row = [
          object.appOrgName
                    ? '"' + object.appOrgName.replace(/"/g, '""') + '"'
                    : '',
          object.appOrgId || "",
           object.appName
                    ? '"' + object.appName.replace(/"/g, '""') + '"'
                    : '',
          object.appId || "",
           object.apiName
                    ? '"' + object.apiName.replace(/"/g, '""') + '"'
                    : '',
          object.apiId || "",
           object.apiPublisherName
                    ? '"' + object.apiPublisherName.replace(/"/g, '""') + '"'
                    : '',
          object.apiPublisherId || "",
        ];
        csvData.push(row);
      });
    }

    return csvData.map((r) => r.join(",")).join(newLine);
  };

  const downloadCSV = (csvString, filename) => {
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = Object.assign(document.createElement("a"), {
      href: url,
      download: filename,
    });
    link.click();
  };

  return (
    <div className="integration-download-button">
      <SecondaryButton
        text="Download Integration Report"
        onClick={handleDownload}
      />
    </div>
  );
};

export default DownloadCSVFile;
